import { FormRenderProps } from "@progress/kendo-react-form";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import React, { useEffect } from "react";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
} from "@progress/kendo-react-grid";

import { Button } from "@progress/kendo-react-buttons";
import {
  HeaderThElement,
  PagerTargetEvent,
} from "@progress/kendo-react-data-tools";
import { CustomAppDialog } from "../../components/dialog/Dialog";
import { LoadingPanel } from "../../components/layout/Loading";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { ImCross } from "react-icons/im";
import AlertBox from "../../components/common/AlertBox";
import {
  findByOrderNoBandhaiReceipt,
  getAllOrderBandhaiIssue,
} from "./services/bandhaiReceipt.services";
import { closeBandhaiReceiptOrderSelectItemDialog } from "./bandhaiReceiptSlice";
import moment from "moment";

interface OrderSelectionDialogProps {
  formRenderProps: FormRenderProps;
  fieldname: string;
}
interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };
const BandhaiOrderSelectionDialog = ({
  formRenderProps,
  fieldname,
}: OrderSelectionDialogProps) => {
  const dispatch = useAppDispatch();
  const BandhaiIssueOrderList = useAppSelector(
    (state) => state.bandhaireceipt.BandhaiIssueOrderList,
  );
  const BandhaiReceiptOrderSelectItemDialog = useAppSelector(
    (state) => state.bandhaireceipt.BandhaiReceiptOrderSelectItemDialog,
  );
  const PurityList = useAppSelector((state) => state.purity?.PurityList);
  const kargigarID = formRenderProps.valueGetter(`karigar_id`);
  const loading = useAppSelector((state) => state.ghatreceipt?.loading);
  const gridRef = React.useRef<any>(null);

  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();
  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All"
        ? BandhaiIssueOrderList.length
        : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  useEffect(() => {
    if (kargigarID) {
      dispatch(getAllOrderBandhaiIssue({ Karigar_id: kargigarID }));
    }
  }, []);
  // const MyImageCommandCell = (props: GridCellProps) => {
  //   const handlClickItem = (image: string) => {
  //     if (image && typeof image === "string") {
  //       window.open(image);
  //     }
  //   };
  //   if (props.dataItem?.image_name === null) {
  //     return (
  //       <div
  //         style={{
  //           display: "flex",
  //           flexDirection: "column",
  //           justifyContent: "center",
  //           alignItems: "center",
  //           height: "50px",
  //         }}
  //       >
  //         <MdOutlineImageNotSupported style={{ fontSize: "30px" }} />
  //         <p style={{ margin: 0, fontSize: "12px" }}>No Image!</p>
  //       </div>
  //     );
  //   }
  //   return (
  //     <td className="action-td main-image">
  //       <div
  //         style={{
  //           position: "relative",
  //           border: "1px dotted lightgrey",
  //           borderRadius: "5px",
  //           overflow: "hidden",
  //           height: "50px",
  //         }}
  //       >
  //         <img
  //           className="product-image"
  //           src={props.dataItem?.image_name}
  //           alt=""
  //           style={{
  //             height: "100%",
  //             width: "100%",
  //             objectFit: "cover",
  //             borderRadius: "5px",
  //           }}
  //         />
  //         <div className="image-view">
  //           <FaRegEye
  //             style={{
  //               color: "white",
  //               height: 24,
  //               width: 24,
  //               cursor: "pointer",
  //             }}
  //             onClick={() => handlClickItem(props.dataItem?.image_name)}
  //           />
  //         </div>
  //       </div>
  //     </td>
  //   );
  // };

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleEditItem = (id: number, order_id: number) => {
      const getOrderNowiseData = async () => {
        if (!order_id || formRenderProps.modified !== true) {
          const updateField = (field: any, value: any) =>
            formRenderProps?.onChange(`${fieldname}.${field}`, { value });
          updateField("item_id", null);
          updateField("item_name", "");
          updateField("order_id", null);
          updateField("order_no", null);
          updateField("ghat_id", null);
          updateField("item_description", "");
          updateField("item_category_id", null);
          updateField("weight", null);
          updateField("purity_id", null);
          updateField("item_image", null);
          updateField("approval_items", []);
          updateField("sizedetails", []);
          return;
        }
        try {
          const getpayload = {
            order_id: order_id,
            bandhai_issue_id: id,
          };
          const { payload: res, meta } = await dispatch(
            findByOrderNoBandhaiReceipt(getpayload),
          );

          if (meta.requestStatus === "fulfilled" && res) {
            const updateField = (field: any, value: any) =>
              formRenderProps?.onChange(`${fieldname}.${field}`, { value });

            if (PurityList && PurityList?.length > 0) {
              const purity = PurityList?.find(
                (item: any) => item.ID === res?.purity_id,
              );
              updateField("purity", purity?.purity);
              updateField("Carat", purity?.Carat);
            }
            updateField("bandhai_issue_id", id);
            updateField("item_id", res?.item_id);
            updateField("item_name", res?.item_name);
            updateField("order_id", res?.order_id);
            updateField("order_no", res?.order_no);
            updateField("ghat_id", res?.ghat_id);
            updateField("item_category_id", res?.item_category_id);
            updateField("item_description", res?.order_process_description);
            updateField("Order_remark", res?.order_vepari_remark);
            updateField("issue_remarks", res?.order_issue_remarks);
            updateField("weight", res?.weight);
            updateField("purity_id", res?.purity_id);
            updateField("item_image", res?.item_image);
            updateField("order_date", res?.order_date);
            updateField("delivery_date", res?.delivery_date);
            updateField("product_name", res?.product_name);
            updateField("category_name", res?.category_name);
            updateField("sub_category_name", res?.sub_category_name);
            updateField("order_estimate_weight", res?.order_estimate_weight);
            updateField("size", res?.size);
            updateField("purity", res?.purity);
            updateField("color", res?.color);
            updateField("priority", res?.priority);
            updateField("karigar_name", res?.karigar_name);
            updateField("given_date", res?.given_date);
            updateField("receive_date", res?.receive_date);
            updateField(
              "approval_items",
              JSON.parse(JSON.stringify(res?.approval_items))?.map(
                (item: any) => ({
                  ghat_id: item.ghat_id,
                  ghat_item_id: item.ghat_item_id,
                  order_id: item.order_id,
                  type: item.type,
                  item_id: item.item_id,
                  weight: item.weight,
                  qty: item.qty,
                  unit_id: item.unit_id,
                  remarks: item.remarks,
                  IssueDate: item.IssueDate
                    ? moment(item.IssueDate, "MM/DD/YYYY").toDate()
                    : "",
                }),
              ),
            );
            updateField(
              "sizedetails",
              JSON.parse(JSON.stringify(res?.sizedetails))?.map(
                (item: any) => ({
                  title: item.title,
                  value: item.value,
                }),
              ),
            );
          } else {
            const updateField = (field: any, value: any) =>
              formRenderProps?.onChange(field, { value });
            updateField("item_id", null);
            updateField("item_name", "");
            updateField("order_id", null);
            updateField("order_no", null);
            updateField("ghat_id", null);
            updateField("item_description", "");
            updateField("item_category_id", null);
            updateField("weight", null);
            updateField("purity_id", null);
            updateField("item_image", null);
            updateField("approval_items", []);
            updateField("sizedetails", []);
          }
        } catch (error) {
          console.error(error);
        }
      };
      getOrderNowiseData();
      dispatch(closeBandhaiReceiptOrderSelectItemDialog());
    };

    return (
      <td className="action-td">
        <Button
          type="button"
          fillMode="solid"
          themeColor={"primary"}
          size="small"
          title="Select Order"
          onClick={() =>
            handleEditItem(props.dataItem.id, props.dataItem?.order_id)
          }
        >
          Select
        </Button>
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 5 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  return (
    <>
      <CustomAppDialog open={BandhaiReceiptOrderSelectItemDialog}>
        <div style={{ width: "70vw" }}>
          {loading && <LoadingPanel gridRef={gridRef} />}
          <GridLayout gap={{ rows: 10, cols: 10 }}>
            <GridLayoutItem
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography.h4 style={{ margin: "0" }}>
                {"Select Order"}
              </Typography.h4>

              <ImCross
                style={{
                  color: "white",
                  background: "red",
                  borderRadius: "50%",
                  padding: "5px",
                  fontSize: "24px",
                }}
                onClick={() =>
                  dispatch(closeBandhaiReceiptOrderSelectItemDialog())
                }
              />
            </GridLayoutItem>
            <GridLayoutItem>
              {BandhaiIssueOrderList && BandhaiIssueOrderList.length ? (
                <KendoGrid
                  className="selection-dialog"
                  style={{ maxHeight: "calc(100vh - 152px)" }}
                  filterable={true}
                  filter={filter}
                  data={
                    filter
                      ? filterBy(BandhaiIssueOrderList, filter).slice(
                          page.skip,
                          page.take + page.skip,
                        )
                      : BandhaiIssueOrderList.slice(
                          page.skip,
                          page.take + page.skip,
                        )
                  }
                  total={BandhaiIssueOrderList.length}
                  onFilterChange={handleFilterChange}
                  skip={page.skip}
                  take={page.take}
                  pageable={{
                    buttonCount: 5,
                    pageSizes: [5, 10, 15, "All"],
                    pageSizeValue: pageSizeValue,
                    type: "input",
                  }}
                  onPageChange={pageChange}
                  cells={{
                    headerCell: HeaderCustomCell,
                    data: MyDataCustomCell,
                  }}
                >
                  {/* <Column
                    field="SelectOrderDialog"
                    title="Image"
                    width={100}
                    cells={{ data: MyImageCommandCell }}
                    filterable={false}
                  /> */}
                  <Column
                    field="order_no"
                    title="Order No"
                    width={"100px"}
                    cells={{
                      data: (props: any) => (
                        <td>
                          <div style={{ color: "green" }}>
                            <strong>
                              {props.dataItem?.order_no}
                              {props.dataItem?.ordersub_no
                                ? `.${props.dataItem?.ordersub_no}`
                                : ""}
                            </strong>
                          </div>
                        </td>
                      ),
                    }}
                  />
                  {/* <Column field="order_id" title="Order ID" /> */}
                  <Column field="karigar_name" title="Karigar Name" />
                  <Column field="item_name" title="Product Name" />
                  <Column field="weight" title="Weight (gm)" />
                  <Column
                    field="issue_date"
                    title="Order Date"
                    cells={{
                      data: (props: any) => (
                        <td>
                          {moment(
                            props.dataItem?.issue_date,
                            "YYYYY-MM-DD",
                          ).format("DD/MM/yyyy")}
                        </td>
                      ),
                    }}
                  />
                  <Column field="approx_delivery_date" title="Delivery Date" />
                  <Column
                    field="order_id"
                    title="Actions"
                    cells={{ data: MyEditCommandCell }}
                    width={"150px"}
                    filterable={false}
                    locked={true}
                  />
                </KendoGrid>
              ) : (
                <AlertBox />
              )}
            </GridLayoutItem>
            <GridLayoutItem
              style={{
                textAlign: "center",
                marginTop: 20,
              }}
            ></GridLayoutItem>
          </GridLayout>
        </div>
      </CustomAppDialog>
    </>
  );
};

export default BandhaiOrderSelectionDialog;
